<template>
  <article class="basic">
    <confirm
      title="您修改了“基本信息”，是否需要保存？"
      cancelText="取消"
      confirmText="保存"
      v-model="show"
      @on-cancel="onCancel"
      @on-confirm="onConfirm">
    </confirm>
    <group>
      <x-input
        v-model="basicInfoData.vin"
        @on-change="vinChange"
        class="vin-number"
        title="车架号"
        :max="17"
        placeholder="输入17位车架号，识别车型">
        <vin-btn
          slot="right"
          :btn-func="searchVin"
          :loading="isSureVinLoading"
          :sure="isSureVin"
          :btn-txt="sureBtnTxt"></vin-btn>
      </x-input>

      <cell @click.native="chooseCarModel" is-link>
        <span class="weui_label" slot="icon">车型</span>
        <span slot="after-title">{{ basicInfoData.car_model_name }}</span>
      </cell>
      <selector
        v-model="basicInfoData.emission_standard"
        placeholder="请选择"
        title="排放标准"
        :options="emissionStandardList"></selector>
      <x-input
        v-model="basicInfoData.mileage"
        title="表显里程"
        placeholder="请输入">
        <span slot="right" class="fc-block">公里</span>
      </x-input>
      <selector
        v-model="basicInfoData.color_id"
        placeholder="请选择"
        title="车身颜色"
        :options="colorList"></selector>
      <cell>
        <span class="weui_label" slot="icon">车身颜色变更</span>
        <div slot="after-title">
          <checker
            v-model="basicInfoData.is_color_changed"
            default-item-class="carColorChange-item"
            selected-item-class="carColorChange-item-selected">
            <checker-item
              v-for="item in carColorChangeRadio"
              :value="item.val" :key="item.key">{{item.key}}</checker-item>
          </checker>
        </div>
      </cell>
      <datetime
        v-model="basicInfoData.production_date"
        title="出厂日期"
        class="time-picker"
        confirm-text="完成"
        cancel-text="取消"
        :min-year="1970"
        format="YYYY-MM-DD"
        :start-date="startDate"
        :end-date="endDate"
        placeholder="请选择">
      </datetime>
      <datetime
        v-model="basicInfoData.license_issued_on"
        title="首次上牌"
        class="time-picker"
        confirm-text="完成"
        cancel-text="取消"
        :min-year="1970"
        format="YYYY-MM-DD"
        :start-date="startDate"
        :end-date="endDate"
        placeholder="请选择">
      </datetime>
      <x-address
        v-model="belongedAddressValue"
        title="车辆归属地"
        @on-change="handleAddress($event, 'belonged')"
        show-name
        class="address-before"
        hide-district
        placeholder="请选择">
      </x-address>
      <x-address
        v-model="locatedAddressValue"
        title="车辆所在地"
        @on-change="handleAddress($event, 'located')"
        show-name
        class="address-before"
        hide-district
        placeholder="请选择">
      </x-address>
      <cell class="plate-cell"  is-link>
        <div slot='icon' class="weui_label">车牌号</div>
        <x-input
          v-model="plateValue"
          slot="after-title"
          class="search-box"
          :max="7"
          :show-clear="false"
          @on-focus="handleFocus"
          :placeholder="'请输入车牌号'"
          :is-type="val_plate_number">
          <div slot="label" class="label" @click="selectPlate">
            <span>{{ plate }}</span>
            <i class="icon"></i>
          </div>
        </x-input>
      </cell>
      <selector
        v-model="basicInfoData.transfer_count"
        title="过户次数"
        :options="transferCountList"
        placeholder="请选择"></selector>
      <datetime
        v-model="basicInfoData.last_transfer_date"
        title="最后过户日期"
        v-if="isShowLastTransferDate"
        class="time-picker"
        confirm-text="完成"
        cancel-text="取消"
        :min-year="1970"
        :start-date="startDate"
        :end-date="endDate"
        format="YYYY-MM-DD"
        placeholder="请选择">
      </datetime>
      <selector
        v-model="basicInfoData.car_character"
        title="车辆性质"
        :options="carCharacterList"
        placeholder="请选择"></selector>
      <selector
        v-model="basicInfoData.usage_character"
        title="使用性质"
        :options="usageCharacterList"
        placeholder="请选择"></selector>
      <cell>
        <span class="weui_label" slot="icon">是否改装</span>
        <div slot="after-title">
          <checker
            v-model="basicInfoData.is_refitted"
            default-item-class="carColorChange-item"
            selected-item-class="carColorChange-item-selected">
            <checker-item
              v-for="item in carRrefitRadio"
              :value="item.val" :key="item.key">{{item.key}}</checker-item>
          </checker>
        </div>
      </cell>
    </group>
    <x-dialog v-model="isShowCarModelDialog" class="car_model_dialog">
      <group title="请选择您的车型">
        <radio :options="modelList" v-model="chooseCar" @on-change="change"></radio>
      </group>
    </x-dialog>
    <footer-btn title="保存基本信息" @submit="toSave('config')"></footer-btn>

    <keyboard
      v-model="showProvinces"
      @handle-value="handleValue"
    >
    </keyboard>
    <keyboard
      v-model="showAlphanumeric"
      @handle-value="handleAlphanumericValue"
      @handle-delete="handleDelete"
      :type="'alphanumeric'">
    </keyboard>
  </article>
</template>

<script>
// 车辆信息(配置信息)
import {
  Cell,
  Selector,
  XInput,
  Group,
  Checker,
  CheckerItem,
  Datetime,
  XAddress,
  Confirm,
  XDialog,
  Radio,
  Keyboard
} from '@lx-frontend/cvux'
import FooterBtn from '../../components/FooterBtn'
import util from '../../../common/util'
import { basic } from './restConfig'
import VinBtn from '../../components/vinBtn'
import cache from '../../../common/cache'
export default {
  components: {
    FooterBtn,
    Cell,
    Selector,
    XInput,
    Group,
    Checker,
    CheckerItem,
    Datetime,
    XAddress,
    Confirm,
    XDialog,
    Radio,
    VinBtn,
    Keyboard
  },
  props: {
    id: [String, Number],
    basicInfoSave: Boolean,
    sourceKey: String,
    basicInfo: Object,
    source: String
  },
  data() {
    return {
      startDate: '1990-01-01', // 日期选择器的结束时间
      endDate: util.formatTime((Date.now() - 24 * 60 * 60 * 1000), 'yyyy-MM-dd'), // 日期选择器的结束时间
      sessionKey: 'auctionBasic', // sessionKey
      show: false, // 是否显示提示弹窗
      originBasicInfo: {}, // 服务器保存的数据
      nextPage: '', // 下个页面
      carModelList: [ // 车型列表
        {
          key: '1',
          value: '两厢车'
        }, {
          key: '2',
          value: '三厢车'
        }, {
          key: '3',
          value: 'SUV'
        }, {
          key: '4',
          value: 'MPV'
        }, {
          key: '5',
          value: '敞篷'
        }, {
          key: '6',
          value: '跑车'
        }, {
          key: '7',
          value: '旅行车'
        }, {
          key: '8',
          value: '皮卡车'
        }, {
          key: '9',
          value: '面包车'
        }, {
          key: '10',
          value: '特种车'
        }, {
          key: '11',
          value: '其他'
        }
      ],
      emissionStandardList: [
        // 排放标准列表
        {
          key: 100,
          value: '低于国一'
        },
        {
          key: 101,
          value: '国一'
        },
        {
          key: 102,
          value: '国二'
        },
        {
          key: 103,
          value: '国三'
        },
        {
          key: 104,
          value: '国四'
        },
        {
          key: 105,
          value: '国五'
        },
        {
          key: 106,
          value: '国六'
        },
        {
          key: 201,
          value: '欧I'
        },
        {
          key: 202,
          value: '欧II'
        },
        {
          key: 203,
          value: '欧III'
        },
        {
          key: 204,
          value: '欧IV'
        },
        {
          key: 205,
          value: '欧V'
        },
        {
          key: 206,
          value: '欧VI'
        },
        {
          key: 305,
          value: '京五'
        },
        {
          key: 400,
          value: '纯电动车'
        },
        {
          key: 500,
          value: '普通混动'
        },
        {
          key: 600,
          value: '插电式混动'
        },
        {
          key: 700,
          value: '增程式混动'
        },
        {
          key: 800,
          value: '氢能源'
        }
      ],
      inletList: [
        // 进气方式列表
        {
          key: '1',
          value: '自然进气'
        }, {
          key: '2',
          value: '涡轮增压'
        }, {
          key: '3',
          value: '机械增压'
        }, {
          key: '4',
          value: '双增压'
        }, {
          key: '5',
          value: '双涡轮增压'
        }, {
          key: '6',
          value: '其他'
        }],
      oilSystemList: [
        // 供油系统列表
        {
          key: '1',
          value: '汽油'
        }, {
          key: '2',
          value: '柴油'
        }, {
          key: '3',
          value: '电动'
        }, {
          key: '4',
          value: '混合'
        }, {
          key: '5',
          value: '其他'
        }
      ],
      transmissionList: [ // 变速箱形式列表
        { key: '1', value: 'MT手动' },
        { key: '2', value: 'AT自动' },
        { key: '3', value: 'AMT机械式变速' },
        { key: '4', value: 'CVT无极' },
        { key: '5', value: 'DSG双离合' },
        { key: '6', value: '手自一体' },
        { key: '7', value: '其他' }
      ],
      driveList: [
        // 驱动形式列表
        {
          key: '1',
          value: 'FR前置后驱'
        }, {
          key: '2',
          value: 'FF前置前驱'
        },
        {
          key: '3',
          value: 'MR中置后驱'
        },
        {
          key: '4',
          value: 'RR后置后驱'
        }, {
          key: '5',
          value: 'FWD前置四驱'
        }, {
          key: '6',
          value: 'MWD中置四驱'
        }, {
          key: '7',
          value: 'RWD后置四驱'
        }, {
          key: '8',
          value: '其他'
        }],
      carColorChangeRadio: [
        {
          key: '有变更',
          val: true
        },
        {
          key: '无',
          val: false
        }
      ],
      carCharacterList: [
        // 车辆性质列表
        {
          key: 1,
          value: '私户'
        },
        {
          key: 2,
          value: '公户'
        }, {
          key: 3,
          value: '外事车'
        }
      ],
      usageCharacterList: [ // 使用性质列表
        {
          key: 1,
          value: '营运'
        },
        {
          key: 2,
          value: '非营运'
        }, {
          key: 3,
          value: '营转非'
        }, {
          key: 4,
          value: '租赁'
        }, {
          key: 5,
          value: '租赁非营运'
        }
      ],
      transferCountList: [
        {
          key: 0,
          value: '0次'
        }, {
          key: 1,
          value: '1次'
        }, {
          key: 2,
          value: '2次'
        }, {
          key: 3,
          value: '3次'
        }, {
          key: 4,
          value: '4次'
        }, {
          key: 5,
          value: '5次'
        }, {
          key: 6,
          value: '6次'
        }, {
          key: 7,
          value: '7次'
        }, {
          key: 8,
          value: '8次'
        }, {
          key: 9,
          value: '9次'
        }, {
          key: 10,
          value: '10次'
        }
      ],
      carRrefitRadio: [ // 是否改装过
        {
          key: '是',
          val: true
        }, {
          key: '否',
          val: false
        }
      ], // 是否改装
      colorList: [ // 颜色列表
        {
          key: '1',
          value: '黑色'
        },
        {
          key: '2',
          value: '白色'
        },
        {
          key: '3',
          value: '银色'
        },
        {
          key: '4',
          value: '灰色'
        },
        {
          key: '5',
          value: '红色'
        },
        {
          key: '6',
          value: '棕色'
        },
        {
          key: '7',
          value: '褐色'
        },
        {
          key: '8',
          value: '蓝色'
        }, {
          key: '9',
          value: '栗色'
        }, {
          key: '10',
          value: '金色'
        },
        {
          key: '11',
          value: '橙色'
        },
        {
          key: '12',
          value: '米色'
        },
        {
          key: '13',
          value: '黄色'
        },
        {
          key: '14',
          value: '紫色'
        },
        {
          key: '15',
          value: '青色'
        },
        {
          key: '16',
          value: '绿色'
        },
        {
          key: '17',
          value: '香槟色'
        },
        {
          key: '18',
          value: '咖啡色'
        },
        {
          key: '19',
          value: '深灰色'
        },
        {
          key: '20',
          value: '银灰色'
        },
        {
          key: '21',
          value: '多彩色'
        }
      ],
      chooseCar: '', // 选择的车型
      isShowCarModelDialog: false, // 是否展示车型dialog
      isRecognizedBrand: false, // 是否通过精真菇识别车型
      modelList: [], // 精真估返回车型列表
      isSureVin: false, // 识别按钮-是否已识别
      isSureVinLoading: false, // 识别按钮-是否识别中
      sureBtnTxt: '识别', // 识别按钮- 按钮上的字
      showProvinces: false, // 控制省份键盘显示
      showAlphanumeric: false, // 控制字母键盘显示
      plate: '粤', // 当前省份
      plateValue: '', // 当前车牌号的关键字
      basicInfoData: {} // 基本信息数据
    }
  },
  created() {
    let basicInfoSession = cache.getSessionData('basicInfo') || {}
    this.basicInfoData = Object.assign({}, this.$store.state.usedCar.carBasicInfo, basicInfoSession)
    this.originBasicInfo = Object.assign({}, this.basicInfoData, basicInfoSession)
    // 如果返回有车牌号，且符合车牌号规则
    if (util.regexpMap.car_plate_number.test(this.basicInfoData.plate_number)) {
      // 初始化数据的时候需要处理 车牌号 拆分 键盘上
      let plate = this.basicInfoData.plate_number.substr(0, 1)
      let plateValue = this.basicInfoData.plate_number.substr(1)
      this.plate = plate
      this.plateValue = plateValue
    }
    // 车型
    let query = this.$route.query
    if (query.car_model_id && query.car_model_name) {
      this.basicInfoData.car_model_id = query.car_model_id // 车型id
      this.basicInfoData.car_model_name = query.car_model_name // 车型名称
    }
  },
  computed: {
    locatedAddressValue: {
      get () {
        let locatedAddressValue = ['110000', '110100'] // 默认北京市
        if (this.basicInfoData.located_province_code) {
          locatedAddressValue[0] = this.basicInfoData.located_province_code
        }
        if (this.basicInfoData.located_city_code) {
          locatedAddressValue[1] = this.basicInfoData.located_city_code
        }
        return locatedAddressValue
      },
      set (val) {
      }
    },
    belongedAddressValue: {
      get () {
        let belongedAddressValue = ['110000', '110100'] // 默认北京市
        if (this.basicInfoData.belonged_province_code) {
          belongedAddressValue[0] = this.basicInfoData.belonged_province_code
        }
        if (this.basicInfoData.belonged_city_code) {
          belongedAddressValue[1] = (this.basicInfoData.belonged_city_code)
        }
        return belongedAddressValue
      },
      set (val) {
      }
    },
    isShowLastTransferDate() {
      return this.basicInfoData.transfer_count > 0
    }
  },
  methods: {
    inspectionEveryItems() {
      let basic = this.basicInfoData
      for (let k in basic) {
        if (k === 'last_transfer_date') {
          if (basic.transfer_count > 0 && basic.last_transfer_date === '') {
            return false
          }
        }
        if (
          k !== 'last_transfer_date' &&
          (basic[k] === null || basic[k] === '' || basic[k].length <= 0)
        ) {
          return false
        }
      }
      return true
    },
    // 从车型组件中选择
    chooseCarModel () {
      cache.setSessionData('basicInfo', this.basicInfoData)
      this.$router.push({
        path: '/car/brand', query: { 'from': this.$route.path }
      })
    },
    getValByKey (key, arr) {
      let item = arr.find(item => {
        return item.key === key
      })
      return item.value
    },
    getError() {
      let error = ''
      let fieldsInfo = {
        car_vin: '请输入正确的车架号',
        car_mileage: '请输入正确的里程',
        car_transfer_count: '请输入正确的过户次数'
      }
      let fields = ['car_vin', 'car_mileage', 'car_transfer_count']
      let item = fields.find((v, index) => {
        let key = v.slice(4)
        let check = this.basicInfoData[key]
        return check && !util.regexpMap[`regexp_${v}`].test(check)
      })
      if (item) {
        error = fieldsInfo[item]
      } else {
        let isReady = this.inspectionEveryItems()
        if (!isReady) error = '请将基本信息填写完整后再保存'
      }
      return error
    },
    toSave(nextPage) {
      let error = this.getError()
      if (!error) {
        let url = basic.saveBasicInfo[this.source](this.id)
        this.$rest.carInfo.create(this.basicInfoData, url).then(res => {
          if (res.code === 0) {
            this.showToast('保存成功')
            // 同步basicInfoSave
            cache.clearSessionData('basicInfo')
            this.$store.dispatch('UPDATE_CAR_BASIC_INFO', this.basicInfoData)
            this.$emit('update:basicInfoSave', true)
            this.$emit('on-after-save', nextPage)
          } else {
            this.nextPage = ''
            this.showToast(res.message)
          }
        })
      } else {
        this.showToast(error)
      }
    },
    goToAnother (nextPage) {
      let originBasicInfo = this.originBasicInfo
      let error = this.getError()
      this.nextPage = nextPage
      this.show = false
      if (error) {
        this.showToast(error)
        return false
      }
      // 是否有改变表单
      this.show = Object.keys(originBasicInfo).some(key => {
        return this.basicInfoData[key] !== originBasicInfo[key]
      })
      if (!this.show) {
        this.$emit('on-after-save', nextPage)
      }
    },
    onConfirm() {
      this.show = false
      this.toSave(this.nextPage)
    },
    onCancel() {
      this.show = false
      // 保存过才可以跳转
      if (this.basicInfoSave) this.$emit('on-after-save', this.nextPage)
    },
    searchVin() { // 搜索车型
      let vin = this.basicInfoData.vin
      if (!util.regexpMap.regexp_car_vin.test(vin)) {
        this.showToast('请输入正确的车架号')
      } else {
        // 识别按钮显示加载中
        this.isSureVinLoading = true
        // 发送ajax请求
        this.$rest.carInfo.query(null, `${vin}/car_models`).then((res) => {
          // 识别按钮加载中隐藏
          this.isSureVinLoading = false
          // 处理返回数据
          if (res.code === 0) {
            this.isRecognizedBrand = true // 精真估拉取车型成功
            let models = res.data.models
            // 只有识别成功才显示已识别按钮
            // 查找不到对应的车型 需要商量
            if (models.length > 1) {
              let list = []
              models.forEach((v, index) => {
                let obj = {
                  key: v.id + '',
                  value: v.model_name
                }
                list.push(obj)
              })
              this.modelList = list
              this.isShowCarModelDialog = true
            } else if (models.length === 1) {
              this.basicInfoData.car_model_id = models[0].id
              this.basicInfoData.car_model_name = models[0].model_name
              this.$emit('on-search-vin', this.basicInfoData.car_model_id)
            } else {
              this.showToast('查找不到对应的车型,请手动选择')
            }

            // 已识别按钮状态
            this.sureBtnTxt = '已识别'
            this.isSureVin = true
          } else {
            // 请求错误，显示默认按钮
            this.sureBtnTxt = '识别'
            this.isSureVin = false
            this.showToast(res.message)
          }
        })
      }
    },
    change(val) {
      let item = this.modelList.find(v => {
        return v.key === val
      })
      this.basicInfoData.car_model_name = item.value
      this.basicInfoData.car_model_id = +item.key
      this.$emit('on-search-vin', this.basicInfoData.car_model_id)
      this.isShowCarModelDialog = false
    },
    vinChange(val) {
      // 没有在识别中的情况下，才变成
      if (!this.isSureVinLoading) {
        // 请求错误，显示默认按钮
        this.sureBtnTxt = '识别'
        this.isSureVin = false
      }
    },
    /**
     * @description 处理省份键盘的值
     * @param value
     */
    handleValue(value) {
      this.plate = value
      this.handleFocus()
    },
    /**
     * @description 处理字母数字键盘的值
     * @param value
     */
    handleAlphanumericValue(value) {
      if (this.plateValue.length < 7) {
        this.plateValue += value
      }
    },
    /**
     * @description 字母数字键盘删除处理
     * @param value
     */
    handleDelete(value) {
      this.plateValue = this.plateValue.substring(0, this.plateValue.length - 1)
    },
    /**
     * @description 处理点击省份按钮，弹起省份键盘
     */
    selectPlate() {
      this.showAlphanumeric = false
      this.showProvinces = true
    },
    /**
     * @description 处理获取表单焦点，阻止手机默认键盘弹起
     */
    handleFocus() {
      document.activeElement.blur()
      this.showAlphanumeric = true
    },
    val_plate_number(val) {
      // 对车牌第一个字母可选。最后一次检查的时候用到
      // 增加小写字母判断，历史数据可能有小写
      let plateReg = /^[\u4e00-\u9fa5]?[A-Za-z]{1}[A-Za-z0-9]{4,5}[A-Za-z0-9\u4e00-\u9fa5]{1}$/
      let valid = plateReg.test(val)
      return this.validate(val, valid, "请选择车牌号，如'粤B12345'")
    },
    validate(val, valid, msg) {
      let info = {}
      if (valid) {
        info.valid = true
        info.msg = ''
      } else {
        info.valid = false
        info.msg = msg
      }
      return info
    },
    /**
     * @description 处理地址的值
     * @param addressData { Object } 处理地址数据
     * @param type 地址类型 { String } 'belonged'、车辆归属地 'located'、车辆所在地
     */
    handleAddress(addressData, type) {
      this.basicInfoData[type + '_province_code'] = addressData.provinceCode
      this.basicInfoData[type + '_province'] = addressData.province
      this.basicInfoData[type + '_city_code'] = addressData.cityCode
      this.basicInfoData[type + '_city'] = addressData.city
    }
  },
  watch: {
    'basicInfoData.vin' (val) {
      this.basicInfoData.vin = val.trim().toUpperCase()
    },
    'basicInfoData.usage_character' (val) {
      if (val) this.basicInfoData.usage_character_name = this.getValByKey(val, this.usageCharacterList)
    },
    'basicInfoData.emission_standard' (val) {
      let item = this.emissionStandardList.find((v) => {
        return v.key === val
      })
      if (item) {
        this.basicInfoData.emission_standard_name = item.value
      }
    },
    'basicInfoData.car_character' (val) {
      if (val) this.basicInfoData.car_character_name = this.getValByKey(val, this.carCharacterList)
    },
    plateValue(newValue, oldValue) {
      if (oldValue.length < 7) {
        this.basicInfoData.plate_number = this.plate + newValue
      }
    },
    plate(newValue, oldValue) {
      this.basicInfoData.plate_number = newValue + this.plateValue
    },
    'basicInfoData.transfer_count' (val) {
      if (!val) {
        this.basicInfoData.last_transfer_date = ''
      }
    }
  }
}
</script>
<style rel="stylesheet/less" lang="less">
@import '../../../stylesheets/modules/manage/input.less';
@w2: 75rem;
.config .tab-service-detail,
.config .tab-service-detail li a {
  padding: 0;
}

.config .weui_cell_primary {
  line-height: 18px;
}

.carColorChange-item,
.fc-block {
  color: #000;
}

.car_model_dialog .weui_dialog {
  text-align: left;
  max-height: 750 / @w2;
  overflow: auto;
}

.plate-cell {
  .search-box {
    padding: 0 !important;
  }
}

.search-box {
  height: 60 / @w2;

  .label {
    display: flex;
    align-items: center;
    padding: 13 / @w2 18 / @w2;
    margin-right: 20 / @w2;
    line-height: 60 / @w2;
    background-color: #eeeeee;
    border-radius: 4 / @w2;
    float: right;
    span {
      display: inline-block;
      font-size: 15px;
      line-height: 15 / @w2;
    }
  }
  .icon {
    display: inline-block;
    margin: 6px 0 0 3px;
    width: 0px;
    height: 0px;
    border: 12 / @w2 solid #5d5c57;
    border-top-color: #5d5c57;
    border-bottom-color: transparent;
    border-left-color: transparent;
    border-right-color: transparent;
  }
}
</style>
